export const tableColumnsNames = [
  'id',
  'applicant',
  'coApplicant',
  'status',
  'type',
  'createdAt',
  'submittedAt',
] as (keyof ApplicationForListingDto)[];

export interface IApplicationsAnalystTableProps {
  searchInputValue: string;
}

enum ApplicationTypeEnum {
  PURCHASE = 'PURCHASE',
  REFINANCE = 'REFINANCE',
}

export type ApplicationForListingDto = {
  title: string;
  purpose: string;
  financingAmount: number;
  id: string | number;
  referenceNumber?: string;
  applicant?: string;
  coApplicant?: string;
  status?: string;
  type?: ApplicationTypeEnum;
  createdAt?: Date;
  updatedAt: Date;
  submittedAt?: Date;
  email?: string;
};
